// extracted by mini-css-extract-plugin
module.exports = {"cartWrapper":"cart_cartWrapper__eEXhH","number":"cart_number__WVWDX"};